<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <CardSettings />
    </div>
    <!-- <div class="w-full lg:w-4/12 px-4"> -->
    <!-- <CardProfile /> -->
    <!-- </div> -->
  </div>
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import CardSettings from "@/components/Cards/CardSettings.vue";
// import CardProfile from "@/components/Cards/CardProfile.vue";


export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("setting", "Settings", "/admin/settings")

    // Use it!



    return {
      appStore
    }
  },
  created() {

  },
  components: {
    CardSettings,
    // CardProfile,
  },
};
</script>
